<template>
  <div class="page-photos" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header title="Photos">
        <div class="columns is-gapless is-vcentered is-flex-mobile has-text-centered" :class="[{ 'is-centered': !isDesktop }]">
          <div class="column" v-if="isDesktop">&nbsp;<!-- stub --></div>
          <div class="column is-narrow subnav-item has-text-left">
            <a href="#" @click="$event.preventDefault();onScrollTo('photos', 'photos-trending')">
              <img src="../assets/ic_hashtag.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                Trending
              </h4>
            </a>
          </div>
          <div class="column is-narrow subnav-item">
            <a href="#" @click="$event.preventDefault();onScrollTo('photos', 'photos-official')">
              <img src="../assets/ic_official.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                Official
              </h4>
            </a>
          </div>
        </div>
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg">

      <!-- <instagram-section id="photos-trending"></instagram-section> -->

      <instagram-section id="photos-official"></instagram-section>

    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import PageHeader from '@/components/PageHeader'
import PageSubheader from '@/components/PageSubheader'
import TopSubpageSection from '@/components/TopSubpageSection'

import InstagramSection from './InstagramSection'

export default {
  name: 'page-photos',
  components: {
    DivContainer,
    PageHeader,
    PageSubheader,
    TopSubpageSection,
    InstagramSection
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: 0 })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-photos {
  position: relative;
  background-color: $color-beige;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }
}

</style>



// WEBPACK FOOTER //
// Photos.vue?5a9d5c14